import axios from "axios";
import { testResponseAuth } from "../../utils";

const baseURL = process.env.REACT_APP_BACKEND_SERVER;

const BearerToken = localStorage.getItem("token");
const config = {
    headers: {
        Authorization: `Bearer ${BearerToken}`,
    },
};

export async function fetchMailers() {
    try {
        const { data } = await axios.get(`${baseURL}/platform-settings/mailers`, config);
        return { isSuccess: true, data };
    } catch (e) {
        testResponseAuth(e.response);
        return {
            isSuccess: false,
            error:
                e.response.data.Error ||
                e.response.data.error ||
                e.response.data.err.message,
        };
    }
}

export async function fetchDomains() {
    try {
        const { data } = await axios.get(`${baseURL}/platform-settings/domains`, config);
        return { isSuccess: true, data };
    } catch (e) {
        testResponseAuth(e.response);
        return {
            isSuccess: false,
            error:
                e.response.data.Error ||
                e.response.data.error ||
                e.response.data.err.message,
        };
    }
}

export async function addDomain(body) {
    try {
        const { data } = await axios.post(
            `${baseURL}/platform-settings/domain`,
            body,
            config
        );
        return { isSuccess: true, data };

    } catch (e) {
        testResponseAuth(e.response);
        return {
            isSuccess: false,
            error:
                e.response.data.Error ||
                e.response.data.error ||
                e.response.data.err.message,
        };
    }
}

export async function addMailer(body) {
    try {
        const { data } = await axios.post(
            `${baseURL}/platform-settings/mailer`,
            body,
            config
        );
        return { isSuccess: true, data };
    } catch (e) {
        testResponseAuth(e.response);
        return {
            isSuccess: false,
            error:
                e.response.data.Error ||
                e.response.data.error ||
                e.response.data.err.message,
        };
    }
}

export async function updateDomain(id, body) {
    try {
        const { data } = await axios.put(
            `${baseURL}/platform-settings/domain/${id}`,
            body,
            config
        );
        return { isSuccess: true, data };

    } catch (e) {
        testResponseAuth(e.response);
        return {
            isSuccess: false,
            error:
                e.response.data.Error ||
                e.response.data.error ||
                e.response.data.err.message,
        };
    }
}

export async function updateMailer(id, body) {
    try {
        const { data } = await axios.put(
            `${baseURL}/platform-settings/mailer/${id}`,
            body,
            config
        );
        return { isSuccess: true, data };
    } catch (e) {
        testResponseAuth(e.response);
        return {
            isSuccess: false,
            error:
                e.response.data.Error ||
                e.response.data.error ||
                e.response.data.err.message,
        };
    }
}

const CompanySettingService = {
    fetchMailers,
    fetchDomains,
    addDomain,
    addMailer,
    updateDomain,
    updateMailer,
};

export default CompanySettingService;
